module.exports = "/static/assets/14db1428fa1036e12731b39dfb449a22.png";